import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural, Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {renderInlineList} from '../../../helpers/listHelpers';
import {AccountModel} from '../../../models/api/accountModel';
import {OkCancelDialog} from '../../common/dialogs/okCancelDialog';

/*
 * Props.
 */

interface RemoveEmailDomainsDialogProps {
  account: AccountModel;
  onClose: HandlerOf<boolean>;
  onRemoveDomains: Handler;
}

/*
 * Style.
 */

const StyledDomainNamesRemovedSpan = styled.span`
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const RemoveEmailDomainsDialog: FC<RemoveEmailDomainsDialogProps> = (props) => {
  const {account, onClose, onRemoveDomains} = props;
  const {domains} = account;
  return (
    <OkCancelDialog
      title={<Trans id="account-details-remove-email-domains-dialog-title">Remove email domains</Trans>}
      okButtonLabel={<Trans id="account-details-remove-email-domains-dialog-remove">Remove</Trans>}
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={() => onClose(false)}
      onOkClick={() => {
        onRemoveDomains();
        onClose(true);
      }}
    >
      <Plural
        id="account-information-remove-email-domains-dialog-disassociation-warning"
        value={domains.length}
        one={
          <>
            Contacts with the <StyledDomainNamesRemovedSpan>{domains[0]}</StyledDomainNamesRemovedSpan> email
            domain will be disassociated from this account. Are you sure you want to continue?
          </>
        }
        other={
          <>
            Contacts with the{' '}
            <StyledDomainNamesRemovedSpan>{renderInlineList(domains)}</StyledDomainNamesRemovedSpan> email
            domains will be disassociated from this account. Are you sure you want to continue?
          </>
        }
      />
    </OkCancelDialog>
  );
};
